<template>
	<!-- 查看弹窗 -->
	<div v-if="vdata&&vdata.isShow">
	    <div class="mask check-log">
	        <div class="e-modal medium">
	            <div class="e-modal-title">View <i class="e-modal-close" @click="vdata.isShow=false"></i></div>
	            <div class="e-modal-body">
	                <table class="check-log-table" cellspacing="0">
	                    <tr>
	                        <td>SN</td>
	                        <td>OrderNum</td>
	                        <td>Operator</td>
	                        <td>OP</td>
	                        <td>Remark</td>
	                        <td>OperationTime</td>
	                    </tr>
	                    <tr v-for="(item,index) in logList">
	                    	<td>{{index+1}}</td>
	                        <td>{{item.PurchaseOrderId}}</td>
	                   
	                        <td>（{{item.Operator}}）</td>
	                        <td>{{item.OperatorType}}</td>
	                 
	                        <td>{{item.Reamrks||'none'}}</td>
													<td>{{item.OperatorDate|dateLong}}</td>
	                    </tr>
	                    <tr v-if="!logList||logList.length<=0">
	                    	<td colspan="6">No related log</td>
	                    </tr>
	                    <tr v-if="logList.length>0">
	                        <td></td>
	                        <td></td>
	                        <td></td>
	                        <td></td>
	                      
	                        <td></td>
	                        <td></td>
	                    </tr>
	                </table>
	            </div>
	        </div>
	    </div>
    </div>
</template>
<script>
export default {
	name: 'orderView',
	props:{
        vdata: {
            type: Object,
 			default: function(){
                return {}
            }
        }
  	},
  	data(){
  		return {
  			logList:[]
  		}
  	},
  	watch:{
  		vdata(val,old){
			if(val!=old){
				this.getLogs();
			}
  			
  		}
  	},
  	methods:{
		getLogs(){
			var that=this;
		
	        var params={
						purchaseOrderId: that.vdata.PurchaseOrderId
	        }
	        that.getRequest({
	            url: that.Api.getOrderLogs,
	            params: params
	        }).then(res => {
	        	
	        	if(res&&res.IsSuccess){
					that.logList=res.Result
	        	}else{
	        		that.logList=[]
	        	}
	        
	        });
		}
  	}


}
</script>


// WEBPACK FOOTER //
// src/components/order/OrderView.vue